<div>
  <div class="form-card">
    <div data-cy="login-welcome" class="form-card-header background-teal-sunrise">
      <div class="form-card-title" data-cy="welcome-title-1">Create a new User</div>
      <ng-container>
        <div class="form-card-subtitle" data-cy="welcome-title-2">Please enter the following information:</div>
      </ng-container>
    </div>

    <div class="form-card-body background-secondary" data-cy="credentials-container">
      <div class="form-card-body-wrapper flex-auto">
        <form [formGroup]="newUserForm" class="new-user-form">
          <div data-cy="user-form-fields items-start">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <input matInput formControlName="username" [maxLength]="40" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" [maxLength]="40" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Phone</mat-label>
              <input matInput formControlName="phone" [maxLength]="40" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" [maxLength]="40" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" [maxLength]="40" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Home App</mat-label>
              <mat-select data-cy="home-app" formControlName="homeApp" required>
                @for (app of applicationService.applications; track app) {
                  <mat-option [value]="app.id">
                    {{ app.displayLabel }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Timezone</mat-label>
              <mat-select data-cy="timezone" formControlName="timezone" required>
                @for (timezone of timezoneService.timezones; track timezone) {
                  <mat-option [value]="timezone.timezoneName">
                    {{ timezone.displayLabel }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Locale</mat-label>
              <mat-select data-cy="locale" formControlName="locale" required>
                @for (locale of localeService.locales; track locale) {
                  <mat-option [value]="locale.localeName">
                    {{ locale.displayLabel }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Preferred Account</mat-label>
              <mat-select data-cy="preferred-account" formControlName="preferredAccount" required>
                @for (account of accountsWithEntities; track account) {
                  <mat-option [value]="account">
                    {{ account.displayLabel }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </form>
        @if (generatedPassword?.length > 0) {
          <div data-cy="generated-password" class="credential-row">
            <span class="credential-label mat-form-field-label">new password:</span>
            <span class="generated-password-value">{{ generatedPassword }}</span>
          </div>
        }
      </div>

      <div data-cy="login-controls-container" class="login-controls-container text-center">
        <span class="submit-new-user-button">
          <button class="x-btn x-btn-primary" [disabled]="!newUserForm.valid" (click)="submitNewUser()">
            Create User
          </button>
        </span>
        <span>
          <button class="x-btn x-btn-secondary" (click)="goBack()">Cancel</button>
        </span>
      </div>
    </div>
  </div>
</div>
